//vue
import Vue from 'vue';
import VueRouter from 'vue-router';
//base
import Login from '../views/Login.vue';
import Home from '../views/Home.vue';
//user
import User from '../views/user/Index.vue';
import UserLista from '../views/user/Lista.vue';
import UserForm from '../views/user/Form.vue';
//nas
import NAS from '../views/nas/Index.vue';
import NASLista from '../views/nas/Lista.vue';
import NASForm from '../views/nas/Form.vue';
//radacct
import RadiusGroup from '../views/radgroup/Index.vue';
import RadiusGroupLista from '../views/radgroup/Lista.vue';
import RadiusGroupForm from '../views/radgroup/Form.vue';
//radacct
import RadiusUser from '../views/raduser/Index.vue';
import RadiusUserLista from '../views/raduser/Lista.vue';
import RadiusUserForm from '../views/raduser/Form.vue';
//radacct
import RadiusAcct from '../views/radacct/Index.vue';
import RadiusAcctLista from '../views/radacct/Lista.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: "/home"
  },
  {
    path: '/login',
    component: Login 
  },
  {
    path: '/home',
    component: Home
  },
  {
    path: '/user',
    component: User,
    children: [
      {
        path: "/",
        component: UserLista
      },
      {
        path: ":id",
        component: UserForm
      }
    ]
  },
  {
    path: '/nas',
    component: NAS,
    children: [
      {
        path: "/",
        component: NASLista
      },
      {
        path: ":id",
        component: NASForm
      }
    ]
  },
  {
    path: '/radgroup',
    component: RadiusGroup,
    children: [
      {
        path: "/",
        component: RadiusGroupLista
      },
      {
        path: ":id",
        component: RadiusGroupForm
      }
    ]
  },
  {
    path: '/raduser',
    component: RadiusUser,
    children: [
      {
        path: "/",
        component: RadiusUserLista
      },
      {
        path: ":id",
        component: RadiusUserForm
      }
    ]
  },
  {
    path: '/radacct',
    component: RadiusAcct,
    children: [
      {
        path: "/",
        component: RadiusAcctLista
      }
    ]
  }
]

const router = new VueRouter({
  routes
});

export default router;
